import React, { useContext, useState, useEffect } from "react";
import { Card, Input, Button, Form, message } from "antd";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "react-router-dom";
import "./LogIn.css";
import logoImage from "../../assets/images/dashboard-vector.png";
import HTTP from "../../services/httpService";
import { SettingContext } from "../../routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import { encrypt } from "../../services/util";
import { queryClient } from "../../App";

const FormItem = Form.Item;
const siteKey = process.env.REACT_APP_SITEKEY;
const loginRecaptchaRef = React.createRef();

function LogIn() {
    let [searchParams] = useSearchParams();
    let adfsEmail = searchParams.get("email");
    const [captchaValue, setCaptchaValue] = useState(null);
    const [loginMessage, setLoginMessage] = useState("");
    const { loggedIn, setLoggedIn } = useContext(SettingContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (loggedIn) {
            queryClient.clear();
            return navigate("/");
        }
    });

    useEffect(() => {
        async function logInWithADFS() {
            if (adfsEmail) {
                const {
                    data: response,
                    success,
                    message,
                } = await HTTP("/users/login", {
                    email: adfsEmail,
                    isAdfsUser: true,
                });
                if (!success) {
                    setLoginMessage(message);
                }
                if (response && response.token) {
                    setLoggedIn(true);
                }
            }
        }
        logInWithADFS();
    }, []);

    // onchange captcha
    const onChangeCaptcha = (value) => {
        setCaptchaValue(value);
    };

    const isLocal = () => {
        if (
            window.location.hostname === "localhost" ||
            window.location.hostname.includes("192.168")
        ) {
            this.isLocal = true;
        }
    };

    const needToBypassCaptchaForUSer = ({ email }) => {
        if (email.length === 7) {
            if (email.toUpperCase() === "ABQ0001") {
                return true;
            }
            return false;
        }
    };

    async function submit(values) {
        if (
            !isLocal &&
            !needToBypassCaptchaForUSer(values) &&
            captchaValue === null
        ) {
            message.warn("Please check captcha first");
        } else {
            values.password = encrypt(values.password);
            try {
                setLoginMessage("");
                const {
                    data: response,
                    success,
                    message,
                } = await HTTP("/users/login", {
                    ...values,
                    google_captcha: captchaValue,
                    isAdfsUser: false,
                });
                if (!success) {
                    setLoginMessage(message);
                }
                if (response && response.token) {
                    setLoggedIn(true);
                }
            } catch (error) {
                setLoginMessage(error);
            }
        }
    }

    return (
        <div className="login-container">
            <Card bordered={false} className="login-card">
                <div>
                    <img
                        src={logoImage}
                        alt="dashboard"
                        className="login-dashboard-vector"
                    />
                </div>
                <div className="login-contents">
                    <span className="login-header">LogIn</span>
                    <span className="login-error-message">{loginMessage}</span>
                    <div className="login-inputs">
                        <Form
                            layout="vertical"
                            onFinish={(values) => submit(values)}
                        >
                            <FormItem
                                name="email"
                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: "Please enter username.",
                                    },
                                ]}
                            >
                                <Input
                                    size="large"
                                    placeholder="Enter username"
                                />
                            </FormItem>
                            <FormItem
                                name="password"
                                rules={[
                                    {
                                        required: true,
                                        whitespace: true,
                                        message: "Please enter password.",
                                    },
                                ]}
                            >
                                <Input.Password
                                    size="large"
                                    type="password"
                                    placeholder="Enter password"
                                />
                            </FormItem>

                            <ReCAPTCHA
                                style={{
                                    marginBottom: 16,
                                    marginLeft: 8,
                                }}
                                sitekey={siteKey}
                                onChange={onChangeCaptcha}
                                ref={loginRecaptchaRef}
                            />

                            <div className="button-link-container">
                                <Button type="primary" htmlType="submit">
                                    Login
                                </Button>
                                <Link to="/forgot-password">
                                    Forgot password?
                                </Link>
                            </div>
                        </Form>
                    </div>
                </div>
                {/* <div>
					<Button type="primary" onClick={callApi}>
						LogIn with ADFS
					</Button>
				</div> */}
            </Card>
        </div>
    );
}

export { LogIn };
